import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private previousUrl: string | undefined = undefined;
  private currentUrl: string | undefined = undefined;

  constructor(private router: Router) {
    this.currentUrl = this.router.url; // Initialize with the current URL
  }

  // Method to manually set the previous URL
  public setPreviousUrl(url: string): void {
    this.previousUrl = url;
  }

  // Method to access the previous URL
  public getPreviousUrl(): string | undefined {
    return this.previousUrl;
  }

  // Method to set the current URL before navigating
  public setCurrentUrl(url: string): void {
    this.currentUrl = url;
  }

  public getCurrentUrl(): string | undefined {
    return this.currentUrl;
  }
}
